// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2x4Yn","log":"ModalInventoryLogs_log__1JGUW","date":"ModalInventoryLogs_date__2L6ip","userName":"ModalInventoryLogs_userName__1I_qf"};